var render = function render(){var _vm=this,_c=_vm._self._c;return _c('share-frame',{staticClass:"dd-celebrate-frame",attrs:{"backgroundColor":_vm.backgroundColor,"logo-color":"white"}},[_c('d-d-celebrate-share-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }